import {Routes} from '@/src/config/routes'

import {PageTransformFn} from '@/src/core/domain/page/functions/types'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'
import {ArticleDetailContent} from '@/src/features/news-articles'
import {ArticlePageContent} from '@/src/(pages)/articles/screen.detail'
import React from 'react'
import {PageType} from '@/src/core/domain/entities/page'
import {parseHTMLContent} from '@/src/shared/modules/html-snippets/parse'

export const articlesTransform: PageTransformFn<ArticleDetailContent> = async function (
  data: ServerPageData<ArticleDetailContent>,
  session,
  isMobile,
) {
  data.breadcrumbs = data.breadcrumbs.map(breadcrumb => ({
    ...breadcrumb,
    url:
      (breadcrumb.url &&
        Routes.articles.section.page(breadcrumb.url, (isMobile && true) || false)) ||
      undefined,
  }))

  if (data.breadcrumbs.length > 0) {
    data.breadcrumbs.unshift({
      title: 'Статьи',
      url: Routes.articles.page,
    })
  } else {
    data.breadcrumbs.unshift({
      title: 'Статьи',
    })
  }

  if (isMobile && data.type === PageType.ArticleDetail) {
    // @ts-ignore TODO: исправить
    data.suspense = {
      content: <ArticlePageContent promise={parseHTMLContent(data.content.article.detail.text)} />,
    }
  }
  return data
}
